import React from "react";
import { Skeleton } from "@mui/material";
import {
	SkeletonCardWrapper,
	SkeletonDetails,
	SkeletonHeader,
	SkeletonWrapper
} from "./ProcessedTrucksListSkeleton.styles";

const ProcessedTrucksCardSkeleton = () => {
	return (
		<SkeletonCardWrapper
			elevation={1}
			square
		>
			<SkeletonHeader>
				<Skeleton
					variant="rounded"
					width="100%"
				/>
			</SkeletonHeader>
			<SkeletonDetails>
				{[...Array(6)].map((_, index) => (
					<Skeleton
						key={`index: ${index}`}
						variant="rounded"
					/>
				))}
			</SkeletonDetails>
		</SkeletonCardWrapper>
	);
};

const ProcessedTrucksListSkeleton: React.FC = () => {
	return (
		<SkeletonWrapper>
			{Array.from({ length: 8 }).map((_, index) => (
				<ProcessedTrucksCardSkeleton key={`index: ${index}`} />
			))}
		</SkeletonWrapper>
	);
};

export default ProcessedTrucksListSkeleton;
